import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate';

export default createStore({
  state: {
    user: {
      /* "beginTime": null,
        "endTime": null,
        "id": 1,
        "companyId": 1,
        "loginName": "admin",
        "userName": "admin",
        "userType": "00",
        "email": "",
        "phonenumber": "",
        "sex": "0",
        "avatar": "",
        "password": null,
        "status": "0",
        "loginIp": "",
        "loginDate": "2023-06-13 16:08:55",
        "creator": "",
        "createTime": null,
        "modifier": "",
        "modifyTime": "2023-06-13 16:08:54",
        "remark": null,
        "newPassword": null,
        "warehouseId": null,
        "roleId": null,
        "warehouseName": null,
        "roleName": null,
        "warehouseIdList": null,
        "roleIdList": null,
        "admin": true */
    },//用户信息
    company: {
      /*  "beginTime": null,
       "endTime": null,
       "id": 1,
       "companyName": "最高公司",
       "companyAddress": "翰林苑",
       "contactWay": "12312312",
       "ownerId": 1,
       "creator": null,
       "createTime": "2023-04-12 13:07:22",
       "modifier": null,
       "modifyTime": null,
       "status": "0",
       "feature": "{\"switch1\":\"0\",\"switch2\":\"0\",\"switch3\":\"1\",\"switch4\":\"0\"}",
       "remark": null,
       "userId": 1,
       "userName": "admin",
       "password": null,
       "loginName": "admin",
       "phonenumber": "",
       "email": "",
       "roleId": 1,
       "ownerName": null,
       "ownerLogin": null */
    },//用户的企业信息
    originBrandList: [],//产地品牌列表
    menuList: [],//菜单结构
    activeMenu: [],//近期打开菜单
    token: '',
  },
  getters: {
    getActiveMenu(state) {
      return state.activeMenu
    }
  },
  mutations: {
    setUserData(state, e) {
      state.user = e;
    },
    setCompanyData(state, e) {
      state.company = e;
    },
    setMenuList(state, e) {
      state.menuList = e;
    },
    setOriginBrandList(state, e) {
      state.originBrandList = e;
    },
    setActiveMenu(state, e) {
      state.activeMenu = e;
    },
    setToken(state, e) {
      state.token = e
    },
    clearStore(state) {
      state.user = {};
      state.company = {};
      state.menuList = [];
      state.originBrandList = [];
      state.activeMenu = [];
      state.token = ''
      sessionStorage.clear()
      localStorage.clear()
    }
  },
  actions: {
    setUserData(storage, e) {
      storage.commit('setUserData', e);
    },
    setCompanyData(storage, e) {
      storage.commit('setCompanyData', e);
    },
    setMenuList(storage, e) {
      storage.commit('setMenuList', e);
    },
    setOriginBrandList(storage, e) {
      storage.commit('setOriginBrandList', e);
    },
    setActiveMenu(storage, e) {
      storage.commit('setActiveMenu', e);
    },
    setToken(storage, e) {
      storage.commit('setToken', e);
    },
    clearStore(storage) {
      storage.commit('clearStore');
    }
  },
  modules: {
  },

  //持久化数据
  plugins: [
    createPersistedState({
      key: 'vuex',
      //可选，sessionStorage/indexDB/localStorage
      storage: window.localStorage
    })
  ]
})
